import { API } from '../utils/amplifyApi';
import { fetchUserAttributes } from 'aws-amplify/auth';
//import { UpdateStatusWithFormFormData } from '../containers/Apartments/AdminView/updateStatusForm'
// import i18n from '../translations/i18n'
import { AddBeforeLoginApartment, ApartmentAdminInfo, ApartmentClientInformation, ApartmentConfirmation, ApartmentInformation, ApartmentMedia, Apartment
//Status
 } from '../types/apartments';
import { Application } from '../types/applications';
import { FileMetadata } from '../types/files';
const createApartment = async () => {
    const apartment: Apartment = await API.post('apartments', '/apartments/smartsale', {});
    return apartment;
};
const removeApartment = async (userId: string, apartmentId: string) => {
    await API.del('apartments', `/users/${userId}/apartments/${apartmentId}`, {});
};
const getApartments = async (query: {
    query?: string;
    status?: string;
} | undefined): Promise<Apartment[]> => {
    let queryString = '';
    const params = new URLSearchParams();
    if (query) {
        if (query.status) {
            params.append('status', query.status);
        }
        if (query.query) {
            params.append('query', query.query);
        }
        queryString = '?' + params.toString();
    }
    const lists: Apartment[] = await API.get('apartments', '/apartments/smartsale' + queryString, {});
    return lists;
};
const getApartment = async (userId: string, apartmentId: string) => {
    let apartment: any = await API.get('apartments', `/users/${userId}/apartments/smartsale/${apartmentId}`, {});
    if (apartment.information?.apartmentNumber && apartment.information?.buildingLetter) {
        apartment.information.buildingLetter += ` ${apartment.information.apartmentNumber}`;
        delete apartment.information.apartmentNumber;
    }
    return apartment;
};
const getApartmentByCode = async (apartmentCode: any): Promise<Apartment> => {
    const apartment: Apartment = await API.get('apartments', `/apartments/${apartmentCode}`, {});
    return apartment;
};
const getApartmentListingData = async (apartmentCode: string): Promise<Apartment> => {
    const apartment: Apartment = await API.get('apartments', `/apartments/${apartmentCode}/listing`, {});
    return apartment;
};
const updateApartmentClientInformation = async (userId: string, apartmentId: string, apartmentClientInformation: ApartmentClientInformation) => {
    const apartment: Apartment = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/client`, {
        body: apartmentClientInformation
    });
    return apartment;
};
const updateApartmentInformation = async (userId: string, apartmentId: string, apartmentInformation: ApartmentInformation) => {
    try {
        const attrs = await fetchUserAttributes();
        const currentUserId = attrs?.sub || null;
        const updatedBody = {
            information: apartmentInformation,
            ...(currentUserId && { currentUserId })
        };
        const apartment = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/information`, {
            body: updatedBody
        });
        return apartment;
    }
    catch (error) {
        console.error('Error updating apartment information:', error);
        throw error;
    }
};
const updateApartmentMedia = async (userId: string, apartmentId: string, apartmentMedia: ApartmentMedia): Promise<Apartment> => {
    const apartment: Apartment = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/update-media`, {
        body: apartmentMedia
    });
    return apartment;
};
const updateApartmentAdminInfo = async (userId: string, apartmentId: string, adminInfo: ApartmentAdminInfo) => {
    const apartment: Apartment = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/adminInfo`, {
        body: adminInfo
    });
    return apartment;
};
const updateApartmentConfirmation = async (userId: string, apartmentId: string, confirmation: ApartmentConfirmation) => {
    const apartment: Apartment = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/confirm`, {
        body: confirmation
    });
    return apartment;
};
const confirmApartmentMedia = async (userId: string, apartmentId: string) => {
    const apartment: Apartment = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/confirmMedia`, {});
    return apartment;
};
const deleteApartmentMedia = async (userId: string, apartmentId: string, body: any) => {
    await API.del('apartments', `/users/${userId}/apartments/${apartmentId}/media`, {
        body
    });
};
// interface UpdateStatusData {
//   status: Status
//   contractWantedApplicationId?: string
//   message?: string
// }
const updateStatus = async (userId: string, apartmentId: string, data: any) => {
    const apartment: Apartment = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/updateStatus`, {
        body: data
    });
    return apartment;
};
const UpdateStatusToRented = async (userId: string, apartmentId: string, data: any) => {
    const apartment: Apartment = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/updatestatustorented`, {
        body: data
    });
    return apartment;
};
const updateMetadata = async (userId: string, apartmentId: string, metadata: string) => {
    const apartment: Apartment = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/metadata`, {
        body: { metadata: `${metadata}` }
    });
    return apartment;
};
const updateApartmentUserId = async (userId: string, apartmentId: string, data: {
    newUserId: string;
}) => {
    const apartment: Apartment = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/userId`, {
        body: data
    });
    return apartment;
};
const updateApartmentViewed = async (userId: string, apartmentId: string): Promise<void> => {
    await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/viewed`, {});
};
export type ApartmentFormType = ApartmentInformation | ApartmentConfirmation;
const validateApartmentForm = async <ApartmentFormType>(formName: 'information' | 'confirmation', formData: ApartmentFormType): Promise<ApartmentFormType> => {
    const data: any = { ...formData };
    const validatedFormData = await API.post('apartments', '/apartments/validate/form', {
        body: {
            formName,
            productType: 'smartsale',
            formData: formName === 'information'
                ? {
                    ...data,
                    postalArea: data.postalArea.value,
                    energyCertification: data.energyCertification.value
                }
                : { ...formData }
        }
    });
    return validatedFormData;
};
/** providing loggedInUserId uses function for authenticated users */
const addAndConfirmBeforeLoginApartment = async (addBeforeLoginApartment: AddBeforeLoginApartment, loggedInUserId?: string) => {
    const confirmedBeforeLoginApartment = await API.post('apartments', loggedInUserId
        ? `/users/${loggedInUserId}/apartments/smartsale/add-and-confirm`
        : '/apartments/smartsale/add-and-confirm', {
        body: addBeforeLoginApartment
    });
    return confirmedBeforeLoginApartment;
};
export interface PreSignedS3URLResponse {
    /** used to connect right file with right URL */
    id: string;
    S3PresignedURL: string;
}
const getMediaUploadPreSignedURLs = async (filesToUploadMetadata: FileMetadata[], userId: string, apartmentId: string) => {
    const presignedS3URLs: PreSignedS3URLResponse[] = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/media`, {
        body: { filesToUploadMetadata }
    });
    return presignedS3URLs;
};
// Kohteen PDF-dokumentit (kauppakirjan liitteet) — erillään media-kuvista
const getDocumentUploadPreSignedURLs = async (filesToUploadMetadata: {
    id: string;
    name: string;
    sizeMB: number;
    type: string;
}[], userId: string, apartmentId: string) => {
    const presignedS3URLs: (PreSignedS3URLResponse & {
        key: string;
    })[] = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/documents`, {
        body: filesToUploadMetadata
    });
    return presignedS3URLs;
};
const updateApartmentDocuments = async (userId: string, apartmentId: string, documents: any[]): Promise<Apartment> => {
    const apartment: Apartment = await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/update-documents`, {
        body: documents
    });
    return apartment;
};
const getApartmentDocumentDownloadURL = async (userId: string, apartmentId: string, documentId: string) => {
    const response: {
        id: string;
        name: string;
        url: string;
    } = await API.get('apartments', `/users/${userId}/apartments/${apartmentId}/documents/${documentId}`, {});
    return response;
};
const updateApartmentCode = async (userId: string, apartmentId: string) => {
    await API.post('apartments', `/users/${userId}/apartments/${apartmentId}/updatecode`, {});
};
const updateApartmentMediaURLs = async (apartmentId: string, keys: string[]) => {
    await API.post('apartments', `/apartments/updateApartmentMediaURLs`, {
        body: {
            apartmentId: apartmentId,
            keys: keys
        }
    });
};
const sendContractInfoRequest = async (application: Application, apartment: Apartment) => {
    await API.post('apartments', `/users/sendcontractinforequest`, {
        body: {
            application: application,
            apartment: apartment
        }
    });
};
const getProducts = async (tags: Array<string>) => {
    try {
        const response = await API.get('apartments', `/apartments/getproducts/${tags.join(',')}`, {});
        return response;
    }
    catch (error) {
        console.error('Error fetching products:', error);
    }
};
const addRights = async (apartment: Apartment, products: Array<string>) => {
    try {
        const response = await API.post('apartments', '/apartments/addrights', {
            body: {
                apartment,
                products
            }
        });
        return response;
    }
    catch (error) {
        console.error('Error adding products:', error);
    }
};
const callOpenAI = async (messages: any, model = 'gpt-4o', temperature = 0.5, max_tokens = 700) => {
    return await API.post('apartments', '/apartments/callopenai', {
        body: {
            messages,
            model,
            temperature,
            max_tokens
        }
    });
};
export default {
    createApartment,
    removeApartment,
    updateApartmentCode,
    getApartments,
    getApartment,
    getApartmentByCode,
    getApartmentListingData,
    updateApartmentClientInformation,
    updateApartmentConfirmation,
    updateApartmentInformation,
    updateApartmentMedia,
    updateApartmentAdminInfo,
    confirmApartmentMedia,
    deleteApartmentMedia,
    updateStatus,
    UpdateStatusToRented,
    updateMetadata,
    updateApartmentUserId,
    updateApartmentViewed,
    validateApartmentForm,
    addAndConfirmBeforeLoginApartment,
    getMediaUploadPreSignedURLs,
    getDocumentUploadPreSignedURLs,
    updateApartmentDocuments,
    getApartmentDocumentDownloadURL,
    sendContractInfoRequest,
    updateApartmentMediaURLs,
    getProducts,
    addRights,
    callOpenAI
};
export { updateApartmentMediaURLs };
